export const namespacedPrefix = '[EMPLOYEES]';
